module.exports = __webpack_public_path__ + "static/img/mGcTu2@2x.09f71469.png";